import { Badge, Icon } from "@elaniintc/goes-design-system";
import type { RenderProps } from "./types";

export default function fileRenderer({ targetField }: RenderProps) {
  const files = targetField?.files;
  if (!files || files.length === 0) {
    return <span className="text-on-disabled-quiet">Vacío</span>;
  }
  return (
    <ul className="flex gap-2 flex-wrap">
      {files.map((f: { id: string; url: string; file_name: string }) => (
        <Badge
          key={f.id}
          variant="neutral"
          className="max-w-70 cursor-pointer"
          onClick={() => window.open(f.url, "_blank", "noopener,noreferrer")}
        >
          <span className="truncate flex-1 min-w-0">{f.file_name}</span>
          <Icon type="fas" name="file" size="xs" className="shrink-0" />
        </Badge>
      ))}
    </ul>
  );
}
